import Panel from './panel.vue';
// import Panel from '../collapse/panel.vue'; iview panel
export default Panel;



// WEBPACK FOOTER //
// ./src/components/panel/index.js